module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mint-image-clip"
  }, [(_vm.type) ? _c('div', {
    staticClass: "mint-image-clip-box"
  }, [_vm._t("left", [_c('input', {
    ref: "camera",
    attrs: {
      "type": "file",
      "accept": "image/*",
      "capture": "camera"
    },
    on: {
      "change": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.stopPropagation();
        _vm.hanldeClick($event)
      }
    }
  })])], 2) : _vm._e(), (!_vm.type) ? _c('div', {
    ref: "crop_btn",
    staticClass: "mint-image-clip-btn"
  }, [_vm._t("default", [_c('mt-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.text))])])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f5b6efb","hasScoped":false,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/image-clip/src/image-clip.vue
// module id = 364
// module chunks = 0